<div id="imageoneEmployee" *ngIf="imageoneEmployee">
    <imageone-employee [pageTitle]="pageTitle" [pageDisplay]="pageDisplay" [id]="id"></imageone-employee>
</div>